import { render, staticRenderFns } from "./ResourceView.vue?vue&type=template&id=cdf95d3e"
import script from "./ResourceView.vue?vue&type=script&lang=js"
export * from "./ResourceView.vue?vue&type=script&lang=js"
import style0 from "./ResourceView.vue?vue&type=style&index=0&id=cdf95d3e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports